// extracted by mini-css-extract-plugin
export default {"container":"b8Wz8Avm4L_Il7TllDAE","heading":"PX9qXTbJ8N_wGdt34ore","cta":"lL1PC46Ury44R00nrbp1"};